
const DAY_VALUE_GET_TIME = 86400000;

export const getItemRecursivo = (path, object) => {

    if (!path || !object) return object;

    if (!path || !object) return null
    // Se nenhum estiver vazio, monta o Path
    path.split('.').forEach(o => {

        if (object) object = object[o]
    })
    return object
}

export const dateTOSave = (dateObj) => {

    if (!dateObj) return dateObj;

    return dateObj.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).replace(/\//g, '/');
}

export function toISOFormat(dateTimeString) {
    if (!dateTimeString) return ' - '

    const novaDate = new Date(dateTimeString)
    // Primeiro, dividimos a data completa em duas partes:
    const [date, time] = dateTimeString.toString().split(' ');

    // Dividimos a data em dia, mês e ano:
    const [DD, MM, YYYY] = date.split('/');

    // Dividimos o tempo em hora e minutos:
    const [HH, mm] = time.split(':');

    // Retornamos a data formatada em um padrão compatível com ISO:
    return `${YYYY}-${MM}-${DD}T${HH}:${mm}`;
}

export function toISOFormat2(dateTimeString) {
    const novaDate = new Date(dateTimeString)
    // Primeiro, dividimos a data completa em duas partes:
    const [date, time] = dateTimeString.toString().split('T');

    // Dividimos a data em dia, mês e ano:
    const [DD, MM, YYYY] = date.split('-');

    // Dividimos o tempo em hora e minutos:
    const [HH, mm] = time.split(':');

    // Retornamos a data formatada em um padrão compatível com ISO:
    return `${DD}-${MM}-${YYYY} ${HH}:${mm}`;
}

export function arraytoISOFormat(date) {

    const YYYY = date[0];
    const MM = date[1];
    const DD = date[2];
    const HH = date[3];
    const mm = date[4];

    // Retornamos a data formatada em um padrão compatível com ISO:
    const dateFormatted = `${YYYY}-${MM}-${DD}T${HH}:${mm}`;

    return dateFormatted
}

export function getDateTimeDay(novaData = null) {
    const date = novaData ? novaData : new Date();
    return new Date(date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).replace(/\//g, '/')).getTime();
}
export function getDateptBR(novaData = null) {
    const date = novaData ? novaData : new Date();
    return new Date(date.toLocaleString('pt-BR', {
        day: '1-digit',
        month: '2-digit',
        year: '4-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).replace(/\//g, '/'));
}

export const dateTimeTOdate = (dateTIME) => {

    if (!dateTIME) return dateTIME;

    const date = new Date(dateTIME);

    const mothFormatted = (date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1;

    return date.getDate() + "/" + mothFormatted + "/" + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
}

export const dateTimeTOdateSemSegundos = (dateTIME) => {

    if (!dateTIME) return dateTIME;

    const date = new Date(dateTIME);

    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes();
}

export const dateTimeTOdateSOData = (dateTIME) => {

    if (!dateTIME) return dateTIME;

    const date = new Date(dateTIME);

    const day = date.getDate().length > 1 ? date.getDate() : '0' + date.getDate();

    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;
}

export const saveDate = (dateTIME) => {

    if (!dateTIME) return dateTIME;

    const date = new Date(dateTIME);

    return new Date(date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds());
}



export const dateDDmmyyyy = (dateObj) => {

    if (!dateObj) return dateObj;

    dateObj = new Intl.DateTimeFormat('pt-BR');

    return dateObj
}
export const clearFormatteDate = (dateObj) => {

    if (!dateObj) return dateObj;

    return new Date(dateObj).toISOString()
        .replace('T', ' ')
        .replace('Z', '')
}

export const toDateFormat = (dateObj) => {
    if (!dateObj) return dateObj;
    return dateObj.toString().toISOString().slice(0, 10);
}

export function dateTImeTOISO(dateTIME) {
    if (!dateTIME) return ' - '
    const date = new Date(dateTIME);
    return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC', hour: true, minute: true }).format(date);
}

export function dateINTLFOrmat(data) {
    return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(data);

}
export function dateINTLDATE(data) {
    //return new Intl.DateTimeFormat('pt-BR', {timeZone: 'UTC'}).format(data);
    return new Intl.DateTimeFormat('pt-BR').format(data)
}

export function dateHoje(Hoje) {
    // var Hoje = new Date();
    Hoje.setDate(Hoje.getDate() - 1);
    //string apenas de data em um formato determinado pelo browser
 //   var Today = Hoje.toDateString();
    // string apenas de data no formato localizado do seu sistema
    var Today2 = Hoje.toLocaleDateString();
//////
    var dataTracinho = Today2.replace(new RegExp("/", "g"), "-");
    return dataTracinho
    // console.log(Today);
    // console.log(Today2);
    // console.log(dataTracinho);
}